// extracted by mini-css-extract-plugin
export default {"cls1":"z_sdMzT5ldXgZw4TTxVV","cls2":"TLIUEbxbzT9vDYl33AbA z_sdMzT5ldXgZw4TTxVV","isTabletUp":"LoKRNWaMWuQMO18cAJKC"};